import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/imgs/star_behaviors_logo.png";
const Header = () => {
  const user = localStorage.getItem("token");
  const user1 = localStorage.getItem("token1");
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate('/');
  };

  const handleLogout1 = () => {
    localStorage.removeItem("token1");
    navigate('/user-login');
  };

  // Just for demonstration, we won't do anything with reg here
  const reg = localStorage.getItem("reg");

  const path = location.pathname;
  console.log('path = ', path)

  return (
    <div className="navbar navbar-light bg-primary p-2" id="ref">
      {/* Logo Image */}
      <div>
        <img
          src={logo}
          alt="Star Behaviors Logo"
          width="200"
          height="48"
        />
      </div>

      {/* Example: conditional logout button(s) */}
      <div style={{ marginLeft: "auto" }}>
        {user && (
          <>

            {
              path === '/user-register' && (
                <Link to="/user-login" className="btn btn-link text-white">
                  Login
                </Link>
              )
            }

            {
              path !== '/user-register' && path !== '/' && (
                <button
                  className="btn btn-link text-white"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              )
            }



          </>
        )}
        {user1 && !user && (
          <button
            className="btn btn-link text-white"
            onClick={handleLogout1}
          >
            Logout
          </button>
        )}
      </div>
    </div>
  );
};

export default Header;
